import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Popover, TextField } from 'seagull';
import { Checkmark, CloseCross } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './DefaultValuePopover.module.scss';
export const GetDefaultValuePopoverTID = (parentTestId)=>getTestIds(parentTestId);
export function DefaultValuePopover(param) {
    let { anchorEl, initialValue, onConfirm, onDismiss, onExited, testId } = param;
    const { DefaultValuePopoverTestIds } = useMemo(()=>GetDefaultValuePopoverTID(testId), [
        testId
    ]);
    const { t: defaultValuePopoverTexts } = useLocaleKeys('components.templateVariables.defaultValuePopover');
    const [value, setValue] = useState('');
    const inputRef = useRef(null);
    useEffect(()=>{
        if (anchorEl) {
            setValue(initialValue !== null && initialValue !== void 0 ? initialValue : '');
        }
    }, [
        anchorEl,
        initialValue
    ]);
    const focusInput = useCallback(()=>{
        var _inputRef_current;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, []);
    const handleConfirm = useCallback(()=>{
        const trimmed = value.trim();
        if (!trimmed) return;
        onConfirm(trimmed);
        setValue('');
    }, [
        value,
        onConfirm
    ]);
    const handleDismiss = useCallback(()=>{
        onDismiss();
        setValue('');
    }, [
        onDismiss
    ]);
    const handleKeyDown = useCallback((event)=>{
        if (event.key === 'Enter') {
            event.preventDefault();
            handleConfirm();
        } else if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            handleDismiss();
        }
    }, [
        handleConfirm,
        handleDismiss
    ]);
    return /*#__PURE__*/ _jsx(Popover, {
        open: !!anchorEl,
        anchorEl: anchorEl,
        onClose: handleDismiss,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        },
        transformOrigin: {
            vertical: -4,
            horizontal: 'left'
        },
        disableAutoFocus: true,
        TransitionProps: {
            onEntered: focusInput,
            onExited
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.content,
            "data-testid": DefaultValuePopoverTestIds.Root(),
            onKeyDown: handleKeyDown,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.textField,
                    children: /*#__PURE__*/ _jsx(TextField, {
                        bi: {
                            name: 'template_variable_default_value'
                        },
                        value: value,
                        onChange: (e)=>setValue(e.target.value),
                        label: defaultValuePopoverTexts.label(),
                        testId: DefaultValuePopoverTestIds.Input(),
                        inputRef: inputRef
                    })
                }),
                /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: styles.dismissButton,
                    onClick: handleDismiss,
                    "data-testid": DefaultValuePopoverTestIds.DismissButton(),
                    "aria-label": defaultValuePopoverTexts.dismiss(),
                    children: /*#__PURE__*/ _jsx(CloseCross, {})
                }),
                /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: styles.confirmButton,
                    onClick: handleConfirm,
                    "data-testid": DefaultValuePopoverTestIds.ConfirmButton(),
                    "aria-label": defaultValuePopoverTexts.confirm(),
                    children: /*#__PURE__*/ _jsx(Checkmark, {})
                })
            ]
        })
    });
}
